import useSWR from 'swr';
import type { IAjaxCallOptions } from '../service/AjaxService';

export function useSwr<TResponse, TError = unknown>(url: string | null, options?: IAjaxCallOptions) {
  return useSWR<TResponse, TError>(url ? [url, options] : null);
}
